import { IRootState } from '../../../store'
import { IHomeState } from '../store/home.types'

export const getHomeSelector = (state: IRootState): IHomeState => state.home
